export default "__VITE_ASSET__8xj5lSsN__"